export default __webpack_public_path__ + "static/media/logo-inverted-minimized.642cd0a0.svg";